<script setup lang="ts">

interface ShopProps {
  id:number;
  name: string;
}
 
 
const props = defineProps<ShopProps>();
//
const config = useRuntimeConfig()
const url = config.public.apiBase + '/product?filter[category_id]='+props.id+'&include=shop,category,media,variations';
//console.log(url)
const { data, status, error } = await useLazyFetch(url);
const products = computed(() => data.value?.data || [])
//
</script>
<template>
       
    <div v-if="status === 'pending'">
        <NavLoading />
    </div>

    <div v-else-if="error">
        Failed to load: {{ error.message }}
    </div>
    <div v-else>
      <div :id="name" class="w-auto px-2">
        <div class="divider"><h2>{{name}}</h2></div>
            <div class="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-4 gap-2 sm:gap-6">
             <div v-for="product in products" :key="product.id">
                <ProductCard
                    :product = product 
                />
             </div>
            </div>
    </div>
    </div>
</template>